var DiscountReferenceModel = /** @class */ (function () {
    function DiscountReferenceModel(data) {
        this.referenceId = data.referenceId;
        this.discountId = data.discountId;
    }
    DiscountReferenceModel.prototype.export = function () {
        var key = this.discountId;
        var exported = {};
        exported[key] = this.referenceId;
        return exported;
    };
    return DiscountReferenceModel;
}());
export default DiscountReferenceModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/DiscountReferenceModel.ts
// module id = null
// module chunks = 